import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import {
  isDesktop, isTablet, isMobileOnly, withOrientationChange, isIOS,
} from 'react-device-detect';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

import PricingPlansTableBody from './PricingPlansTableBody';
import PricingPlansTableHeader from './PricingPlansTableHeader';
import PricingPlansTableBodyMobile from './PricingPlansTableBodyMobile';

import withComponentName from '../../../../../../../decorators/withComponentName';
import windowWidthDecorator from '../../../../../../../decorators/windowWidthDecorator';

import Styles from './style.module.scss';

const cx = classNames.bind(Styles);

export const PricingPlansTable = ({
  activePlanTab, content, headerCells, isLandscape, windowWidth,
}) => {
  const tableRef = useRef();

  const scrollToForm = (e, fromOverlay) => { // scroll to form for overlay
    if (isIOS) {
      e.preventDefault();
    }
    if (fromOverlay) {
      document.querySelector('#overlay_contactus_form').scrollIntoView({
        behavior: 'smooth',
      });
    } else {
      document.querySelector('#contactus-form').scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  const [scrollClassName, setScrollClassName] = useState(false);
  const [scrollLeft, setScrollLeft] = useState(false);
  const [scrollRight, setScrollRight] = useState(true);

  const onScrollTable = () => {
    const {
      scrollLeft, scrollWidth, offsetWidth, scrollTop,
    } = tableRef.current;

    setScrollClassName(scrollTop > 0);
    setScrollLeft(scrollLeft > 0);
    setScrollRight(!((scrollLeft + offsetWidth) >= (scrollWidth - 5)));
  };

  const scrollSide = (direction) => {
    if (direction === 'left') {
      tableRef.current.scrollTo({
        left: tableRef.current.scrollLeft - 50,
        top: tableRef.current.scrollTop,
        behavior: 'smooth',
      });
    } else if (direction === 'right') {
      tableRef.current.scrollTo({
        left: tableRef.current.scrollLeft + 50,
        top: tableRef.current.scrollTop,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const element = tableRef.current;

    element.addEventListener('scroll', onScrollTable);

    return () => {
      element.removeEventListener('scroll', onScrollTable);
    };
  }, []);

  return (
    <>
      <div
        ref={tableRef}
        className={cx('PricingPlans__Table', { [`${activePlanTab}`]: true },
          { 'border-bottom': setScrollClassName },
          { 'border-right': scrollRight })}
      >
        <div onClick={() => scrollSide('left')} className={cx('scrollbar', 'scrollbar--left', { show: scrollLeft })}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
        <table>
          {(((isDesktop || isTablet) && !isMobileOnly) || (isMobileOnly && (isLandscape || (windowWidth > 767))))
            && (
              <>
                <PricingPlansTableHeader
                  activePlanTab={activePlanTab}
                  headerCells={headerCells}
                  scrolling={scrollClassName}
                />
                <PricingPlansTableBody
                  activePlanTab={activePlanTab}
                  tableContent={content}
                  scrollToForm={scrollToForm}
                />
              </>
            )}
          {isMobileOnly && <PricingPlansTableBodyMobile content={content} />}
        </table>
        <div
          onClick={() => scrollSide('right')}
          className={cx('scrollbar', 'scrollbar--right', { show: scrollRight })}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </div>
    </>
  );
};

PricingPlansTable.defaultProps = {
  content: [],
};

PricingPlansTable.propTypes = {
  activePlanTab: PropTypes.string.isRequired,
  content: PropTypes.instanceOf(Array),
};

export default withComponentName(withOrientationChange(windowWidthDecorator(PricingPlansTable)));
